import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
import helpers from 'src/styles/helpers';
import sections from 'src/styles/sections';
const useStyles = makeStyles(_objectSpread(_objectSpread(_objectSpread({}, helpers), sections), {}, {
  exportCSV: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-around'
  },
  filtersWrapper: {
    marginBottom: '10px',
    background: palette.gradients.white,
    padding: '24px',
    boxShadow: palette.shadows.light,
    borderRadius: '2px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: '15px'
  },
  searchWrapper: {
    width: '100%',
    marginRight: '10px'
  },
  tagManager: {
    flexShrink: '0',
    marginLeft: '10px'
  },
  pageWrapper: {
    paddingTop: '32px'
  },
  statusCell: {
    textTransform: 'capitalize'
  },
  periodCell: {
    width: '250px'
  },
  sortByStatusWrapper: {
    width: '23%',
    display: 'flex',
    flexShrink: '0'
  },
  chip: {
    minWidth: '70px'
  },
  rightAlign: {
    textAlign: 'right'
  },
  leftAlign: {
    textAlign: 'left'
  },
  cellContent: {
    padding: '5px 10px',
    width: '100%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  clearSortByStatusWrapper: {
    flexShrink: '0',
    paddingLeft: '8px',
    '& span': {
      width: '48px',
      height: '100%',
      display: 'flex',
      cursor: 'pointer',
      borderRadius: '2px',
      alignItems: 'center',
      justifyContent: 'center',
      border: "1px solid ".concat(palette.shades[500]),
      transition: "all ".concat(palette.transitions.short),
      '&:hover': {
        border: "1px solid ".concat(palette.shades[700])
      }
    }
  },
  createButtons: {
    marginBottom: '10px'
  }
}));
export default useStyles;